<div class="form-group">
  <div class="modalInput__input-wrapper advancedCFAccess__email-input">
    <div class="inputWrapper inputWrapper--disabled">
      <div class="userChips">
        <div class="siteChip">{{ workspaceName }}</div>
      </div>
    </div>
  </div>
</div>
